import { normalise, smallTalkReply, stripLeadingGreeting } from "./smallTalk";

/**
 * Words that start a question or a request, not a name. An unfinished one
 * ("ho", "wh") is included so typing "how do I…" never starts a download.
 */
const QUESTION_WORDS = [
  "how",
  "what",
  "whats",
  "why",
  "when",
  "where",
  "who",
  "which",
  "whose",
  "can",
  "could",
  "would",
  "should",
  "do",
  "does",
  "did",
  "is",
  "are",
  "was",
  "were",
  "please",
  "help",
];

const NAVIGATION = /^(go to|show me|take me to)\b/;

/**
 * Whether typed text can match a Notice, User, family, Circle or file name.
 * Pages and help are searched either way. A question, a greeting or a
 * "go to…" stays off the entity lists, so opening the chat and asking
 * something does not download them.
 */
export function entitySearchIsUseful(text: string): boolean {
  if (text.trim().length < 2 || text.includes("?")) return false;
  if (smallTalkReply(text)) return false;
  const said = stripLeadingGreeting(normalise(text));
  if (said.length < 2 || NAVIGATION.test(said)) return false;
  const [first, ...rest] = said.split(" ");
  if (QUESTION_WORDS.includes(first)) return false;
  if (rest.length === 0 && QUESTION_WORDS.some((word) => word.startsWith(first) && word.length > first.length)) return false;
  return true;
}
